import { Center, Divider, Text, useBreakpointValue } from "@chakra-ui/react";
import { Image } from "@chakra-ui/react";

import RowedDescription from "../../components/rowedDescription";

const Description = () => {
  return (
    <>
      <Text
        fontWeight={700}
        lineHeight={1.2}
        fontSize={useBreakpointValue({ base: "3xl", md: "5xl" })}
        pb={6}
      >
        Letnie Campy 2026
      </Text>

      {/* <AspectRatio height={358} ratio={4 / 3}> */}

      {/* </AspectRatio> */}

      <Text mt={3}>
        Letnie Campy, to wyjazdy wypełnione atrakcjami i aktywnościami -
        zapraszamy do zapisów
      </Text>

      <Divider my={3} />

      <Text my={5}>
        <b>{"Letnie Campy Sportteam (dzieci 5-17 lat)\nJabłonkowy Las - Stare Jabłonki"}</b>
      </Text>
      {RowedDescription({
        rows: [
          ["1 Turnus", "01.07 – 09.07.2026"],
          ["2 Turnus", "09.07 – 17.07.2026"],
          ["3 Turnus", "17.07 – 25.07.2026"],
          ["4 Turnus", "25.07 – 02.08.2026"],
        ],
      })}
      <Image
        src={"/images/summer2024.jpeg"}
        alt="summercamp"
        objectFit="cover"
      />
    </>
  );
};

export default Description;
